stimulusApp.register(
  "cruise-request-guests",
  class extends Stimulus.Controller {
    static targets = ["value", "decrease", "increase"]
    static values = { maxGuests: Number }

    connect() {
      this.#refresh()
    }

    decrease(event) {
      this.#change(event.currentTarget, -1)
    }

    increase(event) {
      this.#change(event.currentTarget, 1)
    }

    #change(button, delta) {
      const input = this.#inputFor(button)
      const min = Number(button.dataset.min)
      const max = Number(button.dataset.max)
      const currentValue = Number(input.value)
      const totalMax =
        delta > 0 ? currentValue + this.maxGuestsValue - this.#totalGuests : max

      const nextValue = Math.max(
        min,
        Math.min(max, totalMax, currentValue + delta),
      )
      if (nextValue === currentValue) return

      input.value = nextValue
      this.#refresh()
      this.dispatch("change", { bubbles: true })
    }

    #refresh() {
      const full = this.#totalGuests >= this.maxGuestsValue

      this.decreaseTargets.forEach((button) => {
        button.disabled =
          Number(this.#inputFor(button).value) <= Number(button.dataset.min)
      })
      this.increaseTargets.forEach((button) => {
        button.disabled =
          full ||
          Number(this.#inputFor(button).value) >= Number(button.dataset.max)
      })
    }

    get #totalGuests() {
      return this.valueTargets
        .map((input) => Number(input.value))
        .reduce((total, count) => total + count, 0)
    }

    #inputFor(button) {
      return this.valueTargets.find(
        (candidate) => candidate.name === button.dataset.attribute,
      )
    }
  },
)
